//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BCard, BCardBody } from 'bootstrap-vue';
import { Icon } from '@iconify/vue2';

export default {
    name: "CourseCardModules",
    components: { BCard, BCardBody, Icon },
    props: {
        courseModules: Array,
        coursePack: Boolean,
        whatWillLearnIntro: String,
        category: [String, Array],
        slug: String,
    },
    computed: {
        // mostrar subchapters solo para el curso de Introducción a la IA
       showSubchapters() {
           return this.slug === 'introduccion-a-la-inteligencia-artificial';
        }
    }
};
